module.exports = __webpack_public_path__ + "media/proximanova-light.106f81cf.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/proximanova-light.ttf
// module id = 101
// module chunks = 9